import SvgIcon, { SvgIconProps } from '@mui/material/SvgIcon';

export const BusinessIcon = (props: SvgIconProps) => (
  <SvgIcon {...props} viewBox="0 0 20 20" fill="none">
    <path
      d="M11.6667 7.575L19.0083 9.03333C19.6 9.15833 20 9.65833 20 10.25V18.75C20 19.4417 19.4417 20 18.75 20H11.25C11.4833 20 11.6667 19.8167 11.6667 19.5833V19.1667H18.75C18.975 19.1667 19.1667 18.9833 19.1667 18.75V10.25C19.1667 10.0583 19.0333 9.88333 18.8417 9.84166L11.6667 8.425V7.575Z"
      fill="#9AB1C0"
    />
    <path
      d="M16.2493 11.6667C16.4827 11.6667 16.666 11.85 16.666 12.0833C16.666 12.3167 16.4827 12.5 16.2493 12.5H14.5827C14.3493 12.5 14.166 12.3167 14.166 12.0833C14.166 11.85 14.3493 11.6667 14.5827 11.6667H16.2493Z"
      fill="#9AB1C0"
    />
    <path
      d="M16.2493 14.1667C16.4827 14.1667 16.666 14.35 16.666 14.5833C16.666 14.8167 16.4827 15 16.2493 15H14.5827C14.3493 15 14.166 14.8167 14.166 14.5833C14.166 14.35 14.3493 14.1667 14.5827 14.1667H16.2493Z"
      fill="#9AB1C0"
    />
    <path
      d="M16.2493 16.6667C16.4827 16.6667 16.666 16.85 16.666 17.0833C16.666 17.3167 16.4827 17.5 16.2493 17.5H14.5827C14.3493 17.5 14.166 17.3167 14.166 17.0833C14.166 16.85 14.3493 16.6667 14.5827 16.6667H16.2493Z"
      fill="#9AB1C0"
    />
    <path
      d="M11.6673 19.5833C11.6673 19.8167 11.484 20 11.2507 20C11.0173 20 10.834 19.8167 10.834 19.5833V19.1667V7.91666C10.834 7.79166 10.8923 7.675 10.984 7.59166C11.084 7.51666 11.209 7.48333 11.334 7.50833L11.6673 7.575V8.425V19.1667V19.5833Z"
      fill="#9AB1C0"
    />
    <path
      d="M10.8327 19.1667V19.5833C10.8327 19.8167 11.016 20 11.2494 20H7.91602C8.14935 20 8.33268 19.8167 8.33268 19.5833V19.1667H10.8327Z"
      fill="#9AB1C0"
    />
    <path
      d="M8.74935 4.16666C8.98269 4.16666 9.16602 4.34999 9.16602 4.58332C9.16602 4.81666 8.98269 4.99999 8.74935 4.99999H7.08268C6.84935 4.99999 6.66602 4.81666 6.66602 4.58332C6.66602 4.34999 6.84935 4.16666 7.08268 4.16666H8.74935Z"
      fill="#9AB1C0"
    />
    <path
      d="M9.16602 7.08332C9.16602 7.31666 8.98269 7.49999 8.74935 7.49999H7.08268C6.84935 7.49999 6.66602 7.31666 6.66602 7.08332C6.66602 6.84999 6.84935 6.66666 7.08268 6.66666H8.74935C8.98269 6.66666 9.16602 6.84999 9.16602 7.08332Z"
      fill="#9AB1C0"
    />
    <path
      d="M8.74935 9.16667C8.98269 9.16667 9.16602 9.35001 9.16602 9.58334C9.16602 9.81667 8.98269 10 8.74935 10H7.08268C6.84935 10 6.66602 9.81667 6.66602 9.58334C6.66602 9.35001 6.84935 9.16667 7.08268 9.16667H8.74935Z"
      fill="#9AB1C0"
    />
    <path
      d="M8.74935 11.6667C8.98269 11.6667 9.16602 11.85 9.16602 12.0833C9.16602 12.3167 8.98269 12.5 8.74935 12.5H7.08268C6.84935 12.5 6.66602 12.3167 6.66602 12.0833C6.66602 11.85 6.84935 11.6667 7.08268 11.6667H8.74935Z"
      fill="#9AB1C0"
    />
    <path
      d="M5 12.0833C5 12.3167 4.81667 12.5 4.58333 12.5H2.91667C2.68333 12.5 2.5 12.3167 2.5 12.0833C2.5 11.85 2.68333 11.6667 2.91667 11.6667H4.58333C4.81667 11.6667 5 11.85 5 12.0833Z"
      fill="#9AB1C0"
    />
    <path
      d="M4.58333 4.16666C4.81667 4.16666 5 4.34999 5 4.58332C5 4.81666 4.81667 4.99999 4.58333 4.99999H2.91667C2.68333 4.99999 2.5 4.81666 2.5 4.58332C2.5 4.34999 2.68333 4.16666 2.91667 4.16666H4.58333Z"
      fill="#9AB1C0"
    />
    <path
      d="M4.58333 6.66666C4.81667 6.66666 5 6.84999 5 7.08332C5 7.31666 4.81667 7.49999 4.58333 7.49999H2.91667C2.68333 7.49999 2.5 7.31666 2.5 7.08332C2.5 6.84999 2.68333 6.66666 2.91667 6.66666H4.58333Z"
      fill="#9AB1C0"
    />
    <path
      d="M4.58333 9.16667C4.81667 9.16667 5 9.35001 5 9.58334C5 9.81667 4.81667 10 4.58333 10H2.91667C2.68333 10 2.5 9.81667 2.5 9.58334C2.5 9.35001 2.68333 9.16667 2.91667 9.16667H4.58333Z"
      fill="#9AB1C0"
    />
    <path
      d="M7.50065 15.4167C7.50065 15.1833 7.30898 15 7.08398 15H4.58398C4.35065 15 4.16732 15.1833 4.16732 15.4167V19.1667H3.33398V15.4167C3.33398 14.725 3.89232 14.1667 4.58398 14.1667H7.08398C7.77565 14.1667 8.33398 14.725 8.33398 15.4167V19.1667H7.50065V15.4167Z"
      fill="#9AB1C0"
    />
    <path
      d="M4.16732 19.1667H7.50065H8.33398V19.5833C8.33398 19.8167 8.15065 20 7.91732 20H3.75065C3.51732 20 3.33398 19.8167 3.33398 19.5833V19.1667H4.16732Z"
      fill="#9AB1C0"
    />
    <path
      d="M1.45833 0.166661L10.6167 1.55833C11.225 1.65833 11.6667 2.17499 11.6667 2.79166V7.575L11.3333 7.50833C11.2083 7.48333 11.0833 7.51666 10.9833 7.59166C10.8917 7.67499 10.8333 7.79166 10.8333 7.91666V2.79166C10.8333 2.58333 10.6833 2.40833 10.4833 2.37499L1.325 0.991661C1.3 0.983327 1.275 0.983327 1.25 0.983327C1.15 0.983327 1.05833 1.01666 0.983333 1.08333C0.883333 1.16666 0.833333 1.27499 0.833333 1.39999V18.75C0.833333 18.9833 1.025 19.1667 1.25 19.1667H3.33333V19.5833C3.33333 19.8167 3.51667 20 3.75 20H1.25C0.558333 20 0 19.4417 0 18.75V1.39999C0 1.03333 0.158333 0.683327 0.441667 0.449994C0.725 0.208327 1.09167 0.108327 1.45833 0.166661V0.166661Z"
      fill="#9AB1C0"
    />
  </SvgIcon>
);
